import type {ConversationMessage, MessageContentFunctionCall} from "@/services/wingman";
import {collectOmegaPresentation, parseOmegaResult} from "@/services/wingman/omega-results";
import {readPublicationReceipt} from "./workflowPublicationReceipt";
import {toolRequestBody} from "./toolRequestBody";

/** Track supersession and runs whose debug-session starts belong to this publication. */
export function workflowPublicationRuns(messages: ConversationMessage[], callId: string, workflowId: string) {
   const publicationIndex = messages.findIndex(message => message.contents.some(part => part.type === "function_result" && part.callId === callId));
   if (publicationIndex < 0) return {runs: [], superseded: false};
   const publication = messages[publicationIndex];
   const receiptIndex = publication.contents.findIndex(part => part.type === "function_result" && part.callId === callId);
   const laterMessages = [
      {...publication, contents: publication.contents.slice(receiptIndex + 1)},
      ...messages.slice(publicationIndex + 1),
   ];
   const starts = new Map<string, MessageContentFunctionCall>();
   const sessionIds = new Set<string>();
   let superseded = false;
   for (const part of laterMessages.flatMap(message => message.contents)) {
      if (part.type === "function_result") {
         if (part.functionName === "omega_publishcustomerworkflow" && readPublicationReceipt(part.result, workflowId)) superseded = true;
         if (part.functionName === "omega_savedraftcustomerworkflow") {
            const result = parseOmegaResult(part.result);
            const body = result?.body as {data?: {id?: unknown}} | undefined;
            if (result?.ok && result.status < 400 && body?.data?.id === workflowId) superseded = true;
         }
      }
      if ((part.type !== "function_call" && part.type !== "function_result") || part.functionName !== "omega_startdebugsession") continue;
      if (part.type === "function_call") {
         if (!superseded) starts.set(part.callId, part);
         continue;
      }
      const start = starts.get(part.callId);
      if (!start || toolRequestBody(start.parameters).workflowId !== workflowId) continue;
      const result = parseOmegaResult(part.result);
      if (!result?.ok || result.status >= 400 || result.body == null || typeof result.body !== "object") continue;
      const sessionId = (result.body as Record<string, unknown>).sessionId;
      if (typeof sessionId === "string" && sessionId) sessionIds.add(sessionId);
   }
   return {runs: collectOmegaPresentation(laterMessages).runs.filter(run => sessionIds.has(run.id) && run.workflowId === workflowId), superseded};
}
